import { useVerifyMutation, useResendCodeMutation } from 'util/rtk-api'
import { useDocTitle } from 'util/hooks'

import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import 'css/pages/verification.css'
import { showToast } from 'components/toast'
import { showMutationError } from 'util/mutation-error'

export const Verification = () => {
	const searchParams = new URLSearchParams(window.location.search)
	const email = searchParams.get('email')
	const navigate = useNavigate()
	const [ verify ] = useVerifyMutation()
	const [ resendCode ] = useResendCodeMutation()

	const [ code, setCode ] = useState()

	const onCodeBlur = ({ target }) => {
		setCode(target.value)

		if (
			target.value.match(/\d{6}/)
		) {
			target.setCustomValidity('')
			return
		}
		
		target.setCustomValidity(
			'The pin should be a 6-digit number.'
		)
	}

	const onFormSubmit = async event => {
		event.preventDefault()

		const result = await verify({ username: email, confirmationCode: code })

		if (showMutationError(result, 'The verification code was not accepted. Please try again.')) return

		navigate('/login')
	}

	const onResendLinkClick = async () => {
		const result = await resendCode({ username: email })

		if (showMutationError(result)) return

		showToast(`A new code has been sent to ${email}`, "success")
	}

	useDocTitle('All for One - Verification Code')

	return (
		<section className="verification-container">
			<h1 className="verification-header">Enter <span className="highlight">verification code</span></h1>

			<p className="verification-note">
				You’ll get an email at {email} if it’s linked to your account.
			</p>

			<form
				id="verification-form"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
				<div className="form-group">
					<input 
						type="tel" 
						id="code" 
						name="code" 
						placeholder="6-digit code" 
						required
						onBlur={onCodeBlur}
					/>
				</div>

				<div className="form-group">
					<button type="submit" className="verification-btn">Next</button>
				</div>
			</form>

			<p className="additional-links">
				Did not receive the email? Check your spam filter or 
				<Link
					to={window.location}
					id="resend-link"
					onClick={onResendLinkClick}
				>
					Resend code
				</Link>
			</p>

			<p className="login-prompt">
				Remembered your password? <Link to="/login" className="login-link">Log in!</Link>
			</p>
		</section>
	)
}
